import i18n from "i18next";
// import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { localeResources, supportedLngs, SupportedLngsType } from "./helper";

const urlParams = new URLSearchParams(window.location.search);
const langParam = urlParams.get("lang");

i18n
  .use(initReactI18next)
  // .use(LanguageDetector)
  .init({
    resources: localeResources,
    // ns: ["translation"],
    // defaultNS: ["translation"],
    lng: langParam === "fr" ? SupportedLngsType.FR : SupportedLngsType.EN,
    fallbackLng: SupportedLngsType.EN,
    supportedLngs: Object.keys(supportedLngs),
    // debug: true,
    interpolation: {
      escapeValue: false,
    },
  })
  .then(() => {
    // console.log("i18n initialized successfully");
  })
  .catch(() => {
    // console.error("Error initializing i18n:", error);
  });
export default i18n;
